export default __webpack_public_path__ + "static/media/b6.5c18c7fc.png";